var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"bgc",attrs:{"type":"warning","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }